module.exports = __webpack_public_path__ + "static/media/quivers.76d669d8.png";